import Cookies from 'js-cookie';
import axios from 'axios';
import { Apis } from '../constants';

import dashboardLayout from '../layout/DashboardLayout.vue';
import dashboard from '../pages/Overview.vue';
import login from '../pages/Login.vue';
import blog from '../pages/blog.vue';
import UserProfile from '../pages/UserProfile.vue';
import Notifications from '../pages/Notifications.vue';
import NewExp from '../pages/NewExp.vue';
import MyExps from '../pages/MyExps.vue';
import MyResponses from '../pages/MyResponses.vue';
import ShowExp from '../pages/ShowExp.vue';
import revisit from '../pages/Revisit.vue';
import Testpage from '../pages/Testpage.vue';


const routes = [
    {
        path: '/',
        name: 'blog',
        component: blog,
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            console.log('blog page');
            next();
        }
    },
    {
        path: '/revisit/:userId',
        name: 'revisit',
        component: revisit,
        meta: { requiresAuth: false },
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem("session_id") != null) {
                next({
                  path: "/"+localStorage.getItem("username") + "/home",
                  query: { redirect: to.fullPath },
                });
              } else {
                next();
              }
        }
    },
    {
        path: '/:username/',
        name: 'userPage',
        component: dashboardLayout,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            console.log('dashboard page');
            next();
        },
        redirect: { name: 'home', params: { username: localStorage.getItem("username") } },
        children: [
            {
                path: 'home',
                name: 'home',
                component: dashboard,
            },
            {
                path: 'profile',
                name: 'profile',
                component: UserProfile,
                beforeEnter: (to, from, next) => {
                    console.log('profile page');
                    next();
                }
            },
            {
                path: 'newexp',
                name: 'newexp',
                component: NewExp,
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => { return 'settings page' },
                beforeEnter: (to, from, next) => {
                    console.log('settings page');
                    next();
                }
            },
            {
                path: 'notifications',
                name: 'notifications',
                component: Notifications,
            },
            {
                path: 'myexps',
                name: 'myexps',
                component: MyExps
            },
            {
                path: 'myresponses',
                name: 'myresponses',
                component: MyResponses,
            }
        ]
    },
    {
        path: '/exp',
        name: 'exp',
        component: dashboardLayout,
        meta: { requiresAuth: false },
        children: [
            {
                path: ':expId/:slug',
                name: 'ShowExp',
                component: ShowExp,
                beforeEnter: (to, from, next) => {
                    console.log('exp page');
                    next();
                }
            },
            {
                path: ':id',
                name: 'test',
                component: Testpage,
                beforeEnter: (to, from, next) => {
                    console.log('test page');
                    next();
                }
            }
        ]
    },
    {
        path: '/*',
        name: 'NotFound',
        component: () => { return 'page not found' },
        beforeEnter: (to, from, next) => {
            console.log('page not found');
            next();
        }
    }
]


export default routes;

